module.exports = __webpack_public_path__ + "static/media/Diglo_banner_horizontal.0bba1073.png";